import React from 'react'
// methods
import classnames from 'classnames'
import moment from 'moment'
import { updateFilter, changeViewToAgenda } from '../../../../components/Header/actions'
import { selected } from '../../../../utils'
import { DAY_HEIGHT, DAYS_OF_WEEK } from '../../utils'
// hooks
import { useDispatch } from 'react-redux'
// components
import { TodaysDate } from './components/TodaysDate'


export default function DayOfTheWeek({ dates, currentDate }) {
  const dispatch = useDispatch()


  return(
    <div className="bg-white w-100" style={{verticalAlign: 'top'}}>
      <div className="d-none border-bottom" style={{ width: '80px', height: DAY_HEIGHT, verticalAlign: 'top' }}></div>
      {dates.map((date, index)=>(
        <div 
          key={index} 
          className={classnames("text-center d-inline-block border-bottom", { 'border-left': index != 0 })}
          style={{ width: 'calc((100% - 10px) / 7)', height: DAY_HEIGHT }}>
          <div 
            className="d-flex flex-column align-items-center h-100 justify-content-center">
            <small 
              style={{fontWeight: selected(date, currentDate) ? '500' : '400' }} 
              className={classnames("pb-1", { "text-secondary": !selected(date, currentDate) })}>
              {DAYS_OF_WEEK[index]}
            </small>
            <TodaysDate
              style={{width: '40px', height: '40px', fontWeight: '500'}}
              onClick={()=>dispatch(updateFilter((date)))}
              onDoubleClick={()=>dispatch(changeViewToAgenda())}
              className={classnames(
                "unselectable rounded-circle d-flex justify-content-center align-items-center cursor-pointer", 
                { "bg-primary": selected(date, currentDate) })}>
              { moment(date).format("D") }
            </TodaysDate>
           </div>
        </div>
      ))}
      <div className="d-inline-block" style={{width: '10px', height: '5px'}}/>
    </div>
  )
}